var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.999V3H9V4.999H5V6.999H19V4.999H15Z",
    fill: "#888D95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.999V19.999C6 21.101 6.897 21.999 8 21.999H16C17.103 21.999 18 21.101 18 19.999V7.999H6ZM11 18H9V12H11V18ZM15 18H13V12H15V18Z",
    fill: "#888D95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash4);
export default __webpack_public_path__ + "static/media/Trash-4.1bafa848.svg";
export { ForwardRef as ReactComponent };